import PostList from './components/PostList';
function App() {
  return (
    <PostList></PostList>
  );
}

export default App;